import { Container } from "reactstrap"

const Dashboard = () => {
  console.log("Dashboard component rendered");
  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="h-100">
            <h6>Dashboard</h6>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Dashboard